export const NOT_AUTHORIZED_MESSAGE = 'User not authenticated!';
